"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuiltInWidgetTypes = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
/* eslint-disable @typescript-eslint/no-empty-interface, import/namespace */
var m = tslib_1.__importStar(require("@gooddata/sdk-model"));
/**
 * List of built-in widget types. These type names are reserved and must not be used by custom widgets.
 * @deprecated Use {@link @gooddata/sdk-model#BuiltInWidgetTypes}
 * @alpha
 */
exports.BuiltInWidgetTypes = m.BuiltInWidgetTypes;
//# sourceMappingURL=baseWidget.js.map